/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject, SensorType, SensorUnits} from '@ion/core/src/types/entities';
import {isImperial} from '@ion/core/src/units/helpers';
import {Unit} from '@ion/core/src/units/units';

export const getDataForRange = (data: any[], range: number[]) => {
  if (range[0] && range[1]) {
    const start = Math.floor((range[0]/100) * data?.length);
    const end = Math.ceil((range[1]/100) * data?.length);
    return data.slice(start, end);
  }
  return data;
};

/**
 * getSensorDataAttributes is a utility function to get the attributes for a sensor type.
 *
 * ```typescript
 *
 * import {getSensorDataAttributes} from '../routes/tracking/sc/reports/utils';
 *
 * const {y: currentValue, eventTime: currentTime} = getSensorDataAttributes(data);
 *
 * ```
 *
 * @param data
 * @returns object with sensor data attributes
 */
export const getSensorDataAttributes = (data: GenericObject) => {
  const index = SensorType.Temperature ? -1 : 0;
  return data?.data?.at?.(index) || {};
};

/**
 * Utility function to get the temperature disply unit for temperature chart/graph tooltip
 *
 * ```typescript
 *
 * import {getTemperatureDisplayUnit} from '../routes/tracking/sc/reports/utils';
 *
 * const displayUnit = getTemperatureDisplayUnit('C', 'Imperial'); // 'F'
 *
 * ```
 *
 * @param data
 * @returns object with sensor data attributes
 */
export const getTemperatureDisplayUnit = (type: SensorUnits, preferredUnit: Unit) => {
  if (isImperial(preferredUnit)) {
    if (type === 'C') {
      return 'F';
    }
    return type;
  } else {
    if (type === 'F') {
      return 'C';
    }
    return type;
  }
};
